import { api } from '@/api/api';

const mapData = {
  fromApi(schema, prefixes) {
    return {
      ...schema,
      editing: false,
      white_list: schema.white_list.map((value) => {
        const prefix = prefixes.find((p) => p.value === value);
        return { value, prefix: prefix ? prefix.prefix : '' };
      }),
    };
  },
  toApi(schema) {
    return {
      ...schema,
      data_type: 'str',
      ...(schema.white_list
        ? { white_list: schema.white_list.map((el) => el.value) }
        : {}),
    };
  },
};

export const segmentSchema = {
  namespaced: true,
  state: {
    fetchingList: false,
    list: [],
    prefixes: [],
  },
  getters: {
    empty(state) {
      return state.list.length === 0;
    },
  },
  mutations: {
    setFetching(state, fetching) {
      state.fetchingList = fetching;
    },
    setSchemas(state, schemas) {
      state.list = schemas;
    },
    addSchema(state, schema) {
      state.list.push(schema);
    },
    setPrefixes(state, prefixes) {
      state.prefixes = prefixes;
    },
  },
  actions: {
    async fetchSchemas({ rootState, commit }) {
      if (
        rootState.company.currentId === -1 ||
        rootState.company.segment.currentId === -1
      ) {
        return;
      }
      commit('setFetching', true);
      const [schemaResponse, prefixResponse] = await Promise.all([
        api.get(
          `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/data_schema_entries/`
        ),
        api.get(
          `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/prefix/`
        ),
      ]);
      commit(
        'setSchemas',
        schemaResponse.data.map((s) => mapData.fromApi(s, prefixResponse.data))
      );
      commit('setPrefixes', prefixResponse.data);
      commit('setFetching', false);
    },
    async updateSchema({ rootState, state, commit, dispatch }, schema) {
      const { data } = await api.patch(
        `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/data_schema_entries/${schema.id}/`,
        mapData.toApi(schema)
      );
      await dispatch('updatePrefixes', schema);
      commit(
        'setSchemas',
        state.list.map((s) => {
          if (s.id === schema.id) {
            return mapData.fromApi(data);
          }
          return s;
        })
      );
    },
    updateSchemaOrder({ rootState, commit }, list) {
      list.forEach((schema, index) =>
        api.patch(
          `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/data_schema_entries/${schema.id}/`,
          {
            order_value: index,
          }
        )
      );
      commit('setSchemas', list);
    },
    async addSchema({ rootState, commit }, schema) {
      const { data } = await api.post(
        `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/data_schema_entries/`,
        mapData.toApi(schema)
      );
      commit('addSchema', mapData.fromApi(data));
    },
    async updatePrefixes({ rootState, state, commit }, schema) {
      const prefixesToKeep = [];
      const prefixesToDelete = [];
      state.prefixes.forEach((p) => {
        const willBeAdded = schema.white_list.find(
          (el) => el.value === p.value
        );
        if (willBeAdded) {
          prefixesToDelete.push(p);
        } else {
          prefixesToKeep.push(p);
        }
      });
      prefixesToDelete.map((p) => {
        return api.delete(
          `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/prefix/${p.id}/`
        );
      });
      const prefixCreations = schema.white_list.flatMap((el) => {
        const existingPrefix = state.prefixes.find((p) => p.value === el.value);
        if (existingPrefix || el.prefix === '') {
          return [];
        }
        return [
          api.post(
            `companies/${rootState.company.currentId}/segments/${rootState.company.segment.currentId}/prefix/`,
            {
              name: schema.name,
              value: el.value,
              prefix: el.prefix,
              segment: rootState.company.segment.currentId,
            }
          ),
        ];
      });
      const createdPrefixes = await Promise.all(prefixCreations);
      commit(
        'setPrefixes',
        createdPrefixes.map((response) => response.data).concat(prefixesToKeep)
      );
    },
  },
};
